import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { stringifyUrl } from 'query-string';
import { adminApi } from '@/services/api';
import { pages } from '@/settings/pages';
import { useApiErrorHandler } from '@/hooks/useApiErrorHandler';
import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';

export const useCheckReAuthenticationExpiration = (
  setIsLoading: (isLoading: boolean) => void,
  fromPath: string,
) => {
  const { apiErrorHandler } = useApiErrorHandler();
  const navigate = useNavigate();
  const gloplaId = useAppSelector(authStore.selectors.gloplaIdSelector);

  return useCallback(async () => {
    setIsLoading(true);

    try {
      const expirationDate = await adminApi.getReAuthenticationExpiration();
      if (expirationDate == null || new Date() > new Date(expirationDate)) {
        const queryParams = {
          prompt: 'login',
          from_path: fromPath,
          glopla_id: gloplaId,
        };
        const signinUri = stringifyUrl({
          url: pages.signin.index,
          query: queryParams,
        });
        navigate(signinUri);
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      apiErrorHandler(err);
    }
  }, [apiErrorHandler, gloplaId, navigate, setIsLoading, fromPath]);
};
